import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Home from "./Pages/Home";
import About from "./Pages/About";
import Projects from "./Pages/Projects";
import CompletedProjects from "./Pages/CompletedProjects";
import Gallery from "./Pages/Gallery";
import Contact from "./Pages/Contact";
import TermsAndConditions from "./components/Termsandconditions";
import Privacypolicy from "./components/Privacypolicy";
import VideoBanner from "./components/VideoBanner";
// import Banners from "./components/Banners";

const App = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/Projects" element={<Projects />} />
        <Route path="/CompletedProjects" element={<CompletedProjects />} />
        <Route path="/Gallery" element={<Gallery />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/Termsandconditions" element={<TermsAndConditions />} />
        <Route path="/Privacypolicy" element={<Privacypolicy />} />
        <Route path="/VideoBanner" element={<VideoBanner />} />
        {/* <Route path="/Banners" element={<Banners />} /> */}
      </Routes>
    </Router>
  );
};

export default App;

